const setPhoneNumber = (value) => {
  return value.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
};

const checkPhoneNumber = (value) => {
  let reg = /(010)([0-9]{4})([0-9]{4})$/;
  return reg.test(value);
};

const checkEmail = (value) => {
  let reg = /^([0-9a-zA-Z_\.-]+)@([a-z_-]+)(\.[a-z_-]+){1,2}$/;
  return reg.test(value);
};

const setOnlyNumbers = (value) => {
  let reg = /[^0-9]/g;
  return value.replace(reg, '');
};

export { setPhoneNumber, checkPhoneNumber, checkEmail, setOnlyNumbers };
